"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagicLoginInputField = void 0;
const react_1 = __importStar(require("react"));
const passportAuth_1 = require("../utils/passportAuth");
require("./MagicLoginInputField.scss");
const MagicLoginInputField_scss_json_1 = __importDefault(require("./MagicLoginInputField.scss.json"));
const TextField_1 = require("lincd-input/lib/components/TextField");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const MagicLoginInputField = ({ name = 'email', placeholder = 'your@email.com', helperText, className, demoCallback, onSubmit, }) => {
    const [email, setEmail] = (0, react_1.useState)('');
    const [loading, setLoading] = (0, react_1.useState)(false);
    // used for displaying a message to the user about attempting sign-in again
    const [hadError, setHadError] = (0, react_1.useState)(false);
    const [hadSuccess, setHadSuccess] = (0, react_1.useState)(false);
    let auth = (0, useAuth_1.useAuth)();
    const handleFormSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setLoading(true);
        try {
            const result = yield (0, passportAuth_1.magicLinkOAuthSignin)(email);
            console.log('[Email] Backend request success', result);
            if (result === null || result === void 0 ? void 0 : result.success) {
                console.log('[Email] Sign-in success');
                setHadSuccess(true);
                setLoading(false);
                if (result.demo) {
                    auth.updateAuth(result.data.auth);
                    if (demoCallback) {
                        return demoCallback();
                    }
                    else {
                        window.location.reload();
                    }
                }
                else {
                    if (onSubmit) {
                        onSubmit();
                    }
                }
            }
            else {
                console.log('[Email] Sign-in error');
                setEmail('');
                setHadError(true);
                setLoading(false);
            }
        }
        catch (err) {
            console.log('err:', err);
        }
    });
    return (react_1.default.createElement("div", { className: MagicLoginInputField_scss_json_1.default.root },
        react_1.default.createElement("form", { className: MagicLoginInputField_scss_json_1.default.form, onSubmit: handleFormSubmit },
            react_1.default.createElement("div", { className: hadSuccess
                    ? MagicLoginInputField_scss_json_1.default.control_success
                    : hadError
                        ? MagicLoginInputField_scss_json_1.default.control_error
                        : MagicLoginInputField_scss_json_1.default.control },
                react_1.default.createElement(TextField_1.TextField, { className: MagicLoginInputField_scss_json_1.default.input, type: 'email', name: name, placeholder: placeholder, value: email, helperText: '', onChange: (e) => {
                        setEmail(e.target.value);
                        if ((hadError || hadSuccess) && e.target.value !== '') {
                            setHadError(false);
                            setHadSuccess(false);
                        }
                    }, endAdornment: react_1.default.createElement("div", { className: MagicLoginInputField_scss_json_1.default.end },
                        react_1.default.createElement("button", { type: "submit", className: MagicLoginInputField_scss_json_1.default.button }, loading ? (react_1.default.createElement("svg", { className: MagicLoginInputField_scss_json_1.default.spinner, width: "24", height: "24", fill: "currentColor" },
                            react_1.default.createElement("path", { d: "M12 4a8 8 0 0 1 7.89 6.7 1.53 1.53 0 0 0 1.49 1.3 1.5 1.5 0 0 0 1.48-1.75 11 11 0 0 0-21.72 0A1.5 1.5 0 0 0 2.62 12a1.53 1.53 0 0 0 1.49-1.3A8 8 0 0 1 12 4Z" }))) : (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", stroke: "currentColor" },
                            react_1.default.createElement("path", { d: "M4 12h16m0 0-6-6m6 6-6 6", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))))) }),
                (helperText || hadError || hadSuccess) && (react_1.default.createElement("div", { className: MagicLoginInputField_scss_json_1.default.helperText }, hadError
                    ? 'Please try again'
                    : hadSuccess
                        ? 'Success!  Please check your e-mail.'
                        : helperText))))));
};
exports.MagicLoginInputField = MagicLoginInputField;
//# sourceMappingURL=MagicLoginInputField.js.map